import { useMemo, useState } from 'react';
import type { RuleOutcome, RunStatus, RunsFilter } from '@/types/rules.types';

/** A filter left on "any". */
export const ALL = 'all';

/** The rule, outcome and status the log is narrowed to; kept by the page so its header can show them. */
export function useRulesActivityFilters() {
	const [ruleId, setRuleId] = useState<string>(ALL);
	const [outcome, setOutcome] = useState<RuleOutcome | typeof ALL>(ALL);
	const [status, setStatus] = useState<RunStatus | typeof ALL>(ALL);
	// Memoised so the query keeps one key until a filter changes.
	const filter = useMemo<RunsFilter>(
		() => ({
			ruleId: ruleId === ALL ? undefined : ruleId,
			outcome: outcome === ALL ? undefined : outcome,
			status: status === ALL ? undefined : status
		}),
		[ruleId, outcome, status]
	);
	const activeCount = [ruleId, outcome, status].filter((value) => value !== ALL).length;
	return { ruleId, setRuleId, outcome, setOutcome, status, setStatus, filter, activeCount };
}

export type RulesActivityFilters = ReturnType<typeof useRulesActivityFilters>;
